<template>
    <b-container class="mt-4" fluid>
        <b-card class="mx-3" header-class="bar-color1">
            <template v-slot:header>
                <i class="far fa-folder-open mr-2"></i>{{ $t('sidebar.documentation') }}
            </template>
            <ul>
                <li v-for="(url, index) in urls" :key="index" class="mb-2">
                    <i class="far fa-file-pdf text-secondary"></i>
                    <a target="_blank" :href="url.url">
                        {{ url.name }}
                    </a>
                </li>

                <li class="mb-2">
                    <i class="fas fa-video text-secondary"></i>
                    <a target="_blank" :href="videoUrl.url">
                        {{ videoUrl.name }}
                    </a>
                </li>
            </ul>
        </b-card>
    </b-container>
</template>

<script>
    export default {
        name: "DocumentationPage",
        computed: {
            urls() {
                return [
                    {
                        url: process.env.VUE_APP_SERVERURL + 'media/private/01_Hemocir CI adultos V1.1.pdf',
                        name: 'Consentimiento informado del paciente adulto',
                    },
                    {
                        url: process.env.VUE_APP_SERVERURL + 'media/private/02_Hemocir CI menores V1.1.pdf',
                        name: 'Consentimiento informado del paciente menor',
                    },
                ];
            },
            videoUrl() {
                return {
                    url: process.env.VUE_APP_SERVERURL + 'media/private/demo.mp4',
                    name: 'Video demostración',
                };
            }
        },
    };
</script>

<style scoped>

</style>
